import { Droplets, Utensils, Home, Heart, Radio, Info, Zap, Shield, Car } from 'lucide-react';

export const areaConfig = {
  water: { icon: Droplets, color: '#6bc5ff' },
  food: { icon: Utensils, color: '#ffcc6b' },
  shelter: { icon: Home, color: '#b86bff' },
  health: { icon: Heart, color: '#ff6b6b' },
  communication: { icon: Radio, color: '#6bffea' },
  information: { icon: Info, color: '#ff6bb3' },
  energy: { icon: Zap, color: '#ffa06b' },
  safety: { icon: Shield, color: '#6bffb3' },
  transport: { icon: Car, color: '#6b8aff' },
} as const;

export type AreaKey = keyof typeof areaConfig;
